import $ from "cash-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default (function () {
    var $heroWrapper;
    var $heroContent;
    var $logo;
    var $header;
    var style, offset, x, y;
    var stuck;
    var threshold;
    var initialWidth;
    var initialHeight;
    var rect;
    var background = false;
    var prevWidth;

    function initScrollTrigger() {
        if (!$heroWrapper?.length) return;

        style = window.getComputedStyle($header[0]);
        offset = parseFloat(window.getComputedStyle($logo[0]).getPropertyValue("right"));
        x = parseFloat(style.getPropertyValue("padding-left"));
        y = parseFloat(style.getPropertyValue("padding-top"));
        // y = x;
        initialWidth = window.innerWidth * 0.9;
        initialHeight = window.innerHeight * 0.9;
        prevWidth = window.innerWidth;

        $heroContent.css({
            "--width": `${initialWidth}px`,
            "--height": `${initialHeight}px`,
        });

        gsap.fromTo(
            $heroContent[0],
            { "--width": `${initialWidth}px`, "--height": `${initialHeight}px` },
            {
                "--width": `${$logo.width() + x + offset}px`,
                "--width": `${$logo.width() * 0.42 + x + offset}`,
                "--height": `${initialHeight}px`,
                scrollTrigger: {
                    trigger: "html",
                    start: "top top",
                    end: `top+=${window.innerHeight} top+=20%`,
                    scrub: 0.5,
                    onUpdate: function (self) {
                        if (self.progress < 1 && background) {
                            $("#header").removeClass("background");
                            background = false;
                        }
                        if (self.progress == 1 && !background) {
                            $("#header").addClass("background");
                            background = true;
                        }
                    },
                },
            }
        );
    }

    function introAnimation() {
        gsap.fromTo(
            $heroContent[0],
            { "--width": `200px`, "--height": `200px` },
            {
                "--width": `${initialWidth}px`,
                "--height": `${initialHeight}px`,
                duration: 2,
                onComplete: function () {
                    $(".site-claim").addClass("on");
                    initScrollTrigger();
                },
            }
        );
    }

    $(window).on("load", function () {
        $heroWrapper = $(".hero");

        if (!$heroWrapper?.length) return;

        $heroContent = $(".hero .inner");
        $logo = $(".site-logo.dynamic");
        $header = $("#header");
        stuck = false;
        threshold = 0;
        initialWidth = window.innerWidth * 0.9;
        initialHeight = window.innerHeight * 0.9;

        introAnimation();

        if (window.scrollY >= window.innerHeight) {
            stuck = true;
            $logo.addClass("stuck");
            $header.addClass("background");
        }
    });

    $(window).on("resizeEnd", function () {
        if (!$heroWrapper?.length) return;
        if (window.innerWidth == prevWidth) return;

        ScrollTrigger.killAll();
        initScrollTrigger();
    });

    $(window).on("scroll", function () {
        if (!$heroWrapper?.length) return;

        rect = $logo[0].getBoundingClientRect();
        if (!stuck && rect.top <= y) {
            stuck = true;
            $logo.addClass("stuck");
            threshold = window.scrollY;
        } else if (window.scrollY <= threshold) {
            stuck = false;
            $logo.removeClass("stuck");
        }
    });
})();
